export const GRID_WIDTH = 12;
export const FORM_MODE_EDIT = 'page-template-form/edit';
export const FORM_MODE_ADD = 'page-template-form/add';
export const FORM_MODE_CLONE = 'page-template-form/clone';
export const REGULAR_SAVE_TYPE = 'page-templates/save-type-regular';
export const CONTINUE_SAVE_TYPE = 'page-templates/save-type-continue';
export const CELL_TYPE = {
  ROOT: 'root',
  ROW: 'row',
  COL: 'col',
};
export const DEFAULT_FORM_VALUES = {
  code: '',
  descr: '',
  configuration: '{\n  "frames": []\n}',
  template: '',
};
